// extracted by mini-css-extract-plugin
export default {"staffListMain":"RolesAndPermissions_staffListMain__1c05h","loader":"RolesAndPermissions_loader__qGgxq"};